import { BrowserRouter, Route, Routes } from "react-router";
import ErrorPage from "@/pages/error";
import { Permiso } from "@/shared/types/permiso";

import ContextLayout from "./layouts/context-layout";
import HomeLayout from "./layouts/home-layout";
import Page from "./layouts/page-layout";

import HomePage from "@/pages/home";
import UsuariosPage from "@/pages/administracion/usuarios";
import RegistroAuditoriasPage from "@/pages/administracion/registro-auditorias";
import RubrosPage from "@/pages/auxiliar/rubros";
import ActividadesComercalesPage from "@/pages/auxiliar/actividades-comerciales";
import ClientesPage from "@/pages/auxiliar/clientes";
import ProveedoresPage from "@/pages/auxiliar/proveedores";
import VendedoresPage from "@/pages/auxiliar/vendedores";
import ArticulosPage from "@/pages/inventario/articulos";
import DepositosPage from "@/pages/inventario/depositos";
import ComprasPage from "@/pages/inventario/compras";
import VentasPage from "@/pages/facturacion/ventas";
import NuevaVentaPage from "@/pages/facturacion/nueva-venta";
import ArticuloTransferenciasPage from "@/pages/inventario/articulo-transferencias";
import ArticuloMovimientosPage from "@/pages/inventario/articulo-movimientos";
import CajasPage from "@/pages/cajas/caja";
import CajaActualPage from "@/pages/cajas/caja-actual";
import HistorialCajaAperturasPage from "@/pages/cajas/historial-caja-aperturas";
import PagosPage from "@/pages/cajas/pagos";
import ConfigurationPage from "@/pages/configuration";
import VentaReportes from "@/pages/reportes/venta-reportes";
import VentaItemReportes from "@/pages/reportes/venta-item-reportes";
import DocumentosElectronicosPage from "@/pages/facturacion-electronica/documentos-electronicos";
import NuevaFacturaElectronicaPage from "@/pages/facturacion-electronica/nueva-factura-electronica";
import NuevaNotaCreditoPage from "@/pages/facturacion-electronica/nueva-nota-credito";
import NuevaAutofacturaPage from "@/pages/facturacion-electronica/nueva-autofactura";
import NuevaNotaRemisionPage from "@/pages/facturacion-electronica/nueva-nota-remision";
import EmisorPage from "../../pages/configuracion/emisor";
import ConfiguracionFacturacionElectronicaPage from "../../pages/configuracion/facturacion-electronica";
import PaisesPage from "../../pages/auxiliar/paises";
import DepartamentosPage from "../../pages/auxiliar/departamentos";
import CiudadesPage from "../../pages/auxiliar/ciudades";
import BarriosPage from "../../pages/auxiliar/barrios";
import OrganizacionesPage from "@/pages/administracion/organizaciones";

export default function AppRoutes() {
    return <BrowserRouter>
        <Routes>
            <Route element={<ContextLayout />}>
                <Route element={<HomeLayout />}>
                    <Route element={<Page />}>
                        <Route index element={<HomePage />} />
                    </Route>
                    <Route element={<Page requireGestion permisos={[Permiso.ReadRubros]} />}>
                        <Route path="rubros" element={<RubrosPage />} />
                    </Route>
                    <Route element={<Page requireFacturacion permisos={[Permiso.ReadActividadesComerciales]} />}>
                        <Route path="actividades-comerciales" element={<ActividadesComercalesPage />} />
                    </Route>
                    <Route element={<Page permisos={[Permiso.ReadClientes]} />}>
                        <Route path="clientes" element={<ClientesPage />} />
                    </Route>
                    <Route element={<Page requireGestion permisos={[Permiso.ReadProveedores]} />}>
                        <Route path="proveedores" element={<ProveedoresPage />} />
                    </Route>
                    <Route element={<Page requireGestion permisos={[Permiso.ReadVendedores]} />}>
                        <Route path="vendedores" element={<VendedoresPage />} />
                    </Route>
                    <Route element={<Page permisos={[Permiso.ManageUsuarios]} />}>
                        <Route path="usuarios" element={<UsuariosPage />} />
                    </Route>
                    <Route element={<Page permisos={[Permiso.ManageOrganizaciones]} />}>
                        <Route path="organizaciones" element={<OrganizacionesPage />} />
                    </Route>
                    <Route element={<Page permisos={[Permiso.Auditoria]} />}>
                        <Route path="auditoria" element={<RegistroAuditoriasPage />} />
                    </Route>
                    <Route element={<Page />}>
                        <Route path="configuracion" element={<ConfigurationPage />} />
                    </Route>
                    <Route element={<Page requireGestion permisos={[Permiso.ReadArticulos]} />}>
                        <Route path="articulos" element={<ArticulosPage />} />
                    </Route>
                    <Route element={<Page requireGestion permisos={[Permiso.ReadDepositos]} />}>
                        <Route path="depositos" element={<DepositosPage />} />
                    </Route>
                    <Route element={<Page requireGestion permisos={[Permiso.ReadCompras]} />}>
                        <Route path="compras" element={<ComprasPage />} />
                    </Route>
                    <Route element={<Page requireGestion permisos={[Permiso.ReadArticuloTransferencias]} />}>
                        <Route path="articulo_transferencias" element={<ArticuloTransferenciasPage />} />
                    </Route>
                    <Route element={<Page requireGestion permisos={[Permiso.ReadArticuloMovimientos]} />}>
                        <Route path="articulo_movimientos" element={<ArticuloMovimientosPage />} />
                    </Route>
                    <Route element={<Page requireGestion permisos={[Permiso.ReadVentas]} />} >
                        <Route path="ventas" element={<VentasPage />} />
                    </Route>
                    <Route element={<Page requireGestion permisos={[Permiso.WriteVentas]} />} >
                        <Route path="nueva_venta" element={<NuevaVentaPage />} />
                    </Route>
                    <Route element={<Page requireGestion permisos={[Permiso.ReadCajas]} />}>
                        <Route path="cajas" element={<CajasPage />} />
                    </Route>
                    <Route element={<Page requireGestion permisos={[Permiso.ReadMovimientoCajas]} />}>
                        <Route path="caja_actual" element={<CajaActualPage />} />
                    </Route>
                    <Route element={<Page requireGestion permisos={[Permiso.HistorialAperturaCajas]} />}>
                        <Route path="caja_historial" element={<HistorialCajaAperturasPage />} />
                    </Route>
                    <Route element={<Page requireGestion permisos={[Permiso.ReadUnpaidVentas]} />}>
                        <Route path="pagar_venta" element={<PagosPage />} />
                    </Route>
                    <Route element={<Page requireGestion permisos={[Permiso.ReporteVentas]} />}>
                        <Route path="reporte_venta" element={<VentaReportes />} />
                    </Route>
                    <Route element={<Page requireGestion permisos={[Permiso.ReporteVentaItems]} />}>
                        <Route path="reporte_venta_item" element={<VentaItemReportes />} />
                    </Route>
                    <Route element={<Page requireFacturacion permisos={[Permiso.ReadDocumentosElectronicos]} />}>
                        <Route path="documentos-electronicos" element={<DocumentosElectronicosPage />} />
                    </Route>
                    <Route element={<Page requireFacturacion permisos={[Permiso.WriteDocumentosElectronicos]} />}>
                        <Route path="nueva-factura-electronica" element={<NuevaFacturaElectronicaPage />} />
                    </Route>
                    <Route element={<Page requireFacturacion permisos={[Permiso.WriteDocumentosElectronicos]} />}>
                        <Route path="nueva-nota-credito" element={<NuevaNotaCreditoPage />} />
                    </Route>
                    <Route element={<Page requireFacturacion permisos={[Permiso.WriteDocumentosElectronicos]} />}>
                        <Route path="nueva-autofactura" element={<NuevaAutofacturaPage />} />
                    </Route>
                    <Route element={<Page requireFacturacion permisos={[Permiso.WriteDocumentosElectronicos]} />}>
                        <Route path="nueva-nota-remision" element={<NuevaNotaRemisionPage />} />
                    </Route>
                    <Route element={<Page requireFacturacion permisos={[Permiso.ManageConfiguracionFacturacionElectronica]} />}>
                        <Route path="configuracion/facturacion-electronica" element={<ConfiguracionFacturacionElectronicaPage />} />
                    </Route>
                    <Route element={<Page requireFacturacion permisos={[Permiso.ManageConfiguracionFacturacionElectronica]} />}>
                        <Route path="configuracion/emisor" element={<EmisorPage />} />
                    </Route>
                    <Route element={<Page permisos={[Permiso.ReadPaises]} />}>
                        <Route path="paises" element={<PaisesPage />} />
                    </Route>
                    <Route element={<Page permisos={[Permiso.ReadDepartamentos]} />}>
                        <Route path="departamentos" element={<DepartamentosPage />} />
                    </Route>
                    <Route element={<Page permisos={[Permiso.ReadCiudadesAndBarrios]} />}>
                        <Route path="ciudades" element={<CiudadesPage />} />
                    </Route>
                    <Route element={<Page permisos={[Permiso.ReadCiudadesAndBarrios]} />}>
                        <Route path="barrios" element={<BarriosPage />} />
                    </Route>
                </Route>
            </Route>
            <Route path="*" element={
                <ErrorPage status="404" title="Página no encontrada"
                    message="La página que buscas no existe o no fue encontrada. Pruebe ingresar en otra dirección." />
            } />
        </Routes>
    </BrowserRouter>
}